module.exports = __webpack_public_path__ + "img/ms-icon-310x310.cb41e0df.png";